import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { CloseConfirmComponent } from 'src/app/admin/close-confirm/close-confirm.component';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { TimeChallengeComponent } from '../time-challenge.component';

@Component({
  selector: 'vex-new-time-challenge',
  templateUrl: './new-time-challenge.component.html',
  styleUrls: ['./new-time-challenge.component.scss']
})
export class NewTimeChallengeComponent implements OnInit {
  item: any = {
    i18nTitle: { EN: "", IT: "" },
    i18nDescription: { EN: "", IT: "" },
    i18nThumb: { EN: "", IT: "" },
    i18nThumbDetail: { EN: "", IT: "" },
    draft: false,
    startDate: '',
    endDate: '',
    acceptancePeriod: null
  };
  constructor(private dialogRef: MatDialogRef<TimeChallengeComponent>, public translate: TranslateService, public restService: RestService, public guiService: GuiService, private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  submit() {
    setTimeout(() => this.guiService.showSpinner = true, 0)
    const param = {
      userId: this.guiService.userLogged.user.id,
      startDate: moment(this.item.startDate).format('YYYY-MM-DD'),
      endDate: moment(this.item.endDate).format('YYYY-MM-DD'),
      acceptancePeriod: this.item.acceptancePeriod,
      i18nTitle: this.item.i18nTitle,
      i18nDescription: this.item.i18nDescription,
      draft: this.item.draft,
      challenges: [],
      i18nThumb: this.item.i18nThumb,
      i18nThumbDetail: this.item.i18nThumbDetail
    };
    this.restService.postService('node', '/create-time-challenge', param).subscribe((ris) => {
      this.dialogRef.close('done')
    })
  }

  confirmClose() {
    this.dialog.open(CloseConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      panelClass: 'close-dialog-modalbox'
    }).afterClosed().subscribe((ris) => {
      if (ris == 'true') {
        this.dialogRef.close()
      }
    })
  }

  isFormInvalid(): boolean {
    const item = this.item;
    return !item ||
      !item.i18nTitle?.IT ||
      !item.i18nTitle?.EN ||
      !item.i18nDescription?.IT ||
      !item.i18nDescription?.EN ||
      !item.i18nThumb?.IT ||
      !item.i18nThumb?.EN ||
      !item.i18nThumbDetail?.IT ||
      !item.i18nThumbDetail?.EN ||
      !item.startDate ||
      !item.endDate ||
      item.acceptancePeriod == null
  }
}
